import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { SystemService } from './system.service';
import { BaseDataService } from './basedata.service';
import { API_URL } from 'common/constants/url.constants';
import { BaseDataModel } from 'common/models/utilitymodels/base.model';
import { StorageConstants } from 'common/constants/app.constant';
import { environment } from 'common/environment/environment.dev';

export class ErroModel extends BaseDataModel {
    error: any;
    module: string;
}

@Injectable({
    providedIn: 'root',
})
export class GlobalErrorHandlerService extends BaseDataService<ErroModel> {
    constructor(protected httpService: HttpService, private systemService: SystemService) {
        super(API_URL.cloudErrUrl, httpService);
    }

    public dataModel(): ErroModel {
        return new ErroModel();
    }
    handleError(err: ErroModel): Promise<string> {
        const prepareErrObj = {
            type: this.systemService.deviceInfo.platform,
            appId: this.systemService.deviceId || '',
            module: err.module,
            timestamp: this.systemService.formatDateForTransactionAPI(new Date().toDateString()),
            error_log: JSON.stringify(err.error),
            ip: this.systemService.getLocalStorage(StorageConstants.ipAddress),
        };

        return new Promise((resolve, reject) => {
            this.httpService
                .postUrlToError(environment.cloudErrUrl, prepareErrObj)
                .then((data) => {
                    resolve('Request Send Succesfully');
                })
                .catch((err) => {
                    resolve('Something Went wrong while request');
                });
        });
    }
}
